export const ADMIN_LOGIN_PATH = '/admin/login';
export const ADMIN_SIGNUP_PATH = '/admin/signup';
export const ADMIN_CONFIRM_EMAIL_PATH = '/admin/confirm-email/:token';
export const ADMIN_CONFIRM_INVITATION_PATH = '/admin/confirm-invitation/:token';
export const ADMIN_FORGOT_PASSWORD_PATH = '/admin/forgot-password';
export const ADMIN_RESET_PASSWORD_PATH = '/admin/reset-password/:token';
